const whiteList = ["/", '/logins']; // 路由白名单，不需要校验
import store from '@/store'
export default router => {
  const type = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 2 : 1
  router.beforeEach(async (to, from, next) => {
    /*在跳转之前执行*/
    // if (to.path === '/pc_login' || to.path === '/m_login') {
    if (to.path === '/pc_login') {
      next();
    } else {
      const userInfo = sessionStorage.getItem("userName");
      if (userInfo) {
        next();
      } else {
        // next(type === 1 ? '/pc_login' : '/m_login');
        next('/pc_login');
      }
    }
  });
};


// WEBPACK FOOTER //
// ./src/utils/routerutil.js